import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import { usePolicyPageData } from 'src/app/pages/legal/policy/pageContext';
import type { PolicySlug } from 'src/app/pages/legal/policy/shared/utils';

type Result = ModelHookResult<{
	activeTab: PolicySlug;
	items: Array<{ id: PolicySlug; href: string; label: string }>;
}>;

export function usePageTabs(): Result {
	const {
		data: { slug },
	} = usePolicyPageData();

	const { translate } = useI18n();

	return {
		data: {
			activeTab: slug,
			items: useMemo(() => {
				return [
					{
						id: 'policies',
						href: '/policies',
						label: translate('fe.components.brand_pages_navbar.policies'),
					},
					{
						id: 'terms',
						href: '/policies/terms-of-service',
						label: translate('fe.components.brand_pages_navbar.terms'),
					},
					{
						id: 'privacy',
						href: '/policies/privacy',
						label: translate('fe.components.brand_pages_navbar.privacy'),
					},
					{
						id: 'cookies',
						href: '/policies/cookies',
						label: translate('fe.components.brand_pages_navbar.cookies'),
					},
					{
						id: 'community',
						href: '/policies/community',
						label: translate('fe.components.brand_pages_navbar.community_guidelines'),
					},
				];
			}, [translate]),
		},
	};
}
